module.exports = __webpack_public_path__ + "img/level_05_gold.99bf328b.svg";